import React from "react";
import { Stack } from "@mui/material";
import LogoImg from "../Logo";
import Typography from "@common/components/Typography";

const ScreenSaver = ({
  text,
  pulsating = false,
}: {
  text?: string;
  pulsating?: boolean;
}) => (
  <Stack
    sx={{
      justifyContent: "center",
      height: "100%",

      "@keyframes pulse": {
        "0%": {
          opacity: 1,
        },
        "50%": {
          opacity: 0.5,
        },
        "100%": {
          opacity: 1,
        },
      },
      animation: pulsating ? "pulse 3s infinite" : "",
    }}
  >
    <LogoImg big={!text} sx={{ alignSelf: "center" }} />
    {text && (
      <Typography
        size="medium"
        variant="caption"
        align="center"
        sx={(theme) => ({ color: theme.palette.common.grey.g9B9B9B })}
      >
        {text}
      </Typography>
    )}
  </Stack>
);

export default ScreenSaver;
